import styled from 'styled-components';
import typings from '@designSystem/typings';

export default styled.input`
  ${typings.commonTyping}
  border-radius: 8px;
  width: 100%;
  height: 40px;
  padding: 10px 15px;
  box-sizing: border-box;
`;
